export default __webpack_public_path__ + "static/media/file_example_MP3_5MG.f23f9d95.mp3";